import React, { useEffect, FC, useState } from "react";
import { Route, Switch, useHistory, Link, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { Avatar, Dropdown, Menu, message, Divider } from "antd";
import "./index.less";
import * as actions from "@/store/actions";
import axios from "@/axios/axios";

import { getCookie } from "@/common/utils";
import Header from "@/components/header/index";
import Footer from "@/components/footer/index";
interface Props extends DefaultProps {
  routes: any[];
  storeData: any;
  setUserInfo: (params: any) => any;
  setNavIndex: (params: any) => any;
}

const IndexPage: FC<Props> = ({
  history,
  routes,
  storeData,
  setUserInfo,
  setNavIndex,
}) => {
  const { userInfo = {}, navIndex } = storeData;
  useEffect(() => {
    getUserInfo();
  }, []);
  const logOut = async () => {
    const { success, message: msg }: any = await axios.post("/user/web/exit");
    if (success) {
      setUserInfo({ userInfo: null });
      history.replace("/login");
    } else {
      message.error(msg);
    }
  };

  const menu = (
    <Menu>
      <Menu.Item>
        <Link to="/index/personCenter/learnRecord">学习记录</Link>
      </Menu.Item>
      <Menu.Item>
        <div
          onClick={() => {
            logOut();
          }}
        >
          退出
        </div>
      </Menu.Item>
    </Menu>
  );

  const getUserInfo = () => {
    let userId = getCookie("X-MVW-userID");
    const { name = "" } = userInfo || {};
    // 有cookie 并且本地没有存储姓名
    console.log("userId", userId);
    console.log("userInfo", userInfo);
    if (userId && !name) {
      axios.post(`/user/api/continuing/userInfo`, {}).then((res: any) => {
        const { code, data } = res;
        if (code === 0) {
          const { name, avatar } = data;
          setUserInfo({ userInfo: { name, avatar } });
        }
      });
    }
  };

  return (
    <div className={"home-new-page"}>
      <Header />
      <div
        className={"home-content"}
        style={{ minHeight: `calc(100% - 210px)` }}
      >
        <Switch>
          {routes.map((route: any, i: number) => (
            <Route
              key={i}
              path={route.path}
              render={(props) => <route.component {...props} />}
            />
          ))}
          {/* <Redirect path="/index/" exact={true} to="/index/home" /> */}
        </Switch>
      </div>
      <Footer />
    </div>
  );
};

export default connect((state) => state, actions)(IndexPage);
